import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { useParams } from 'react-router-dom';
import sal from 'sal.js';

import './Specialties.css';
import Banner from './partials/Banner';
import SpecFaq from './partials/SpecFaq';
import StatsSection from './partials/StatsSection';
import FaqSection from '../home/partials/FaqSection';
import DoctorsSection from '../home/partials/DoctorsSection';
import TestimonialSection from '../home/partials/TestimonialSection';
import GastroTreatmentCarousel from './partials/GastroTreatmentCarousel';

const Specialties = () => {
  const { slug } = useParams();
  const [specialtyData, setSpecialtyData] = useState(null);
  const [doctors, setDoctors] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [genFaqs, setGenFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSpecialtyData = async () => {
      setLoading(true);
      setError(null);

      try {
        const [specialtyRes, doctorsRes, testimonialsRes, genFaqsRes] = await Promise.all([
          api.get(`/api/specialties/${slug}`),
          api.get(`/api/doctors/screen/${slug}`),
          api.get(`/api/testimonials/screen/${slug}`),
          api.get(`/api/faqs/screen/${slug}`),
        ]);

        setSpecialtyData(specialtyRes.data);
        setDoctors(doctorsRes.data);
        setTestimonials(testimonialsRes.data);
        setGenFaqs(genFaqsRes.data);
      } catch (err) {
        console.error('Error fetching specialty data:', err);
        setError('Failed to load specialty data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    if (slug) fetchSpecialtyData();
  }, [slug]);

  useEffect(() => {
    if (specialtyData) {
      setTimeout(() => sal({ threshold: 0.2, once: true }), 300);
    }
  }, [specialtyData]);

  if (error) return null;
  if (!specialtyData || !specialtyData.banner)
    return null;

  const { banner, stats, treatments, faqs } = specialtyData;
  const specName = specialtyData.name ?? '';

  const BannerSkeleton = () => (
    <section className="banner-section">
      <div className="skeleton shimmer" style={{ height: "520px", borderRadius: "0" }}></div>
    </section>
  );

  return (
    <>
      {loading ? <BannerSkeleton /> : (banner?.heading && ( <Banner
        specName={specName}
        heading={banner.heading}
        description={banner.description}
        backgroundImageUrl={banner.background_image_url}
        mainImageUrl={banner.main_image_url}
        buttons={banner.buttons || []}
        iconData={banner.icon_data || []}
      /> ))}

      {stats?.stats?.length > 0 && <StatsSection statItems={stats.stats} />}

      {treatments?.treatments?.length >= 3 && <GastroTreatmentCarousel heading={treatments.heading} treatments={treatments.treatments} />}

      {faqs?.faqs?.length > 0 && <SpecFaq heading={faqs.heading} imageUrl={faqs.image_url} faqs={faqs.faqs} slug={specName} />}

      {doctors.length > 0 && <DoctorsSection doctors={doctors} />}

      {testimonials?.items?.length > 0 && <TestimonialSection testimonials={testimonials} />}

      {genFaqs.length > 0 && <FaqSection faqs={genFaqs} />}
    </>
  );
};

export default Specialties;
